import React, {useCallback, useMemo, useRef, useState} from 'react';
import {useFocusEffect, useRoute} from '@react-navigation/native';
import {useRequest} from 'ahooks';
import PromotionCard from './promotion-card';
import Spin from '@/components/basic/spin';
import theme from '@/style';
import {getPromotionEntryList} from './service';
import {useLogin} from '@/utils/state-hooks';
import NoData from '@/components/basic/error-pages/no-data';
import {PromotionAnchorItem} from './promotion-anchor.utils';
import {usePromotionAnchor} from './promotion-anchor.hooks';
import {PromotionDownloadModal} from './promotion-download-modal';

const Promotion = () => {
  const login = useLogin();
  const route = useRoute();
  const {tabKey, entryId, ptype, id} = (route.params || {}) as Record<
    string,
    string
  >;
  const cardRefs = useRef<Array<HTMLDivElement | null>>([]);
  const [downloadModalOpen, setDownloadModalOpen] = useState(false);
  const [downloadModalImageUrl, setDownloadModalImageUrl] = useState('');
  const {
    data: promotionResponse,
    loading,
    run: reload,
  } = useRequest(getPromotionEntryList, {manual: true});
  const items = useMemo(
    () => promotionResponse?.items || [],
    [promotionResponse?.items],
  );
  const anchorItems = useMemo<PromotionAnchorItem[]>(
    () => items.map(item => ({entryId: item.entryId})),
    [items],
  );

  useFocusEffect(
    useCallback(() => {
      reload();
    }, [reload]),
  );

  usePromotionAnchor({
    ready: !loading,
    anchorItems,
    anchorParams: {
      tabKey,
      entryId,
      ptype,
      id,
    },
    cardRefs,
  });

  return (
    <>
      <Spin style={[theme.flex.flex1, theme.flex.col]} loading={loading}>
        <div className="flex flex-1 flex-col gap-2 overflow-auto px-2 py-3">
          {items.map((item, index) => (
            <div
              className="flex-none"
              key={item.entryId}
              ref={element => {
                cardRefs.current[index] = element;
              }}>
              <PromotionCard
                item={item}
                login={login}
                onDownloadApp={modalImageUrl => {
                  setDownloadModalImageUrl(modalImageUrl || '');
                  setDownloadModalOpen(true);
                }}
              />
            </div>
          ))}
          {items.length > 0 ? null : <NoData />}
        </div>
      </Spin>
      <PromotionDownloadModal
        open={downloadModalOpen}
        imageUrl={downloadModalImageUrl}
        onClose={() => setDownloadModalOpen(false)}
      />
    </>
  );
};

export default Promotion;
